import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Addresses = ({
  onChange,
  disabled,
  error,
  title,
  addresses,
  contact_addresses,
  addNewItem,
  removeItem,
  ...props
}) => {

  const handleChange = event => {
    onChange(event, 'addresses')
  }

  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem('address_ids');
  }

  const handleRemoveItem = (event, idx) =>{
    event.preventDefault();
    event.stopPropagation();
    removeItem('address_ids', idx)
  }

  const classes = useStyles();

  const getAddress = (id) => { 
    var address = contact_addresses.filter(address => parseInt(address.id) === parseInt(id))
    var formatted_address = id
    if (address[0]){
      //formatted_address = JSON.parse(address[0].data).formatted_address
      formatted_address = address[0].formattedAddress
    }

    return formatted_address
  }

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      {addresses.address_ids.map((val, idx)=>{
        return (
          <React.Fragment>
            <div className="row ml-1">
              {(addresses.address_ids[idx].address_id === '') ?

                <FormControl className="mr-2" style={{minWidth: 200, fontSize: '0.75rem'}} name={'address_id.'+ idx} >
                  <InputLabel htmlFor="grouped-native-select" autoWidth="true" style={{minWidth: 200, fontSize: '0.75rem'}} >Seleccione la dirección</InputLabel>
                  <Select native name={'address_id.'+ idx}
                      inputProps={{
                        name:"address_id."+ idx,
                        className:"address_id."+ idx
                      }}
                      style={{minWidth: 200, fontSize: '0.75rem'}}
                      disabled={disabled}
                      onChange={handleChange}
                      error={(error !=='' && addresses.address_id ==='') ? 'Debe completar este campo' :  false }
                      value={addresses.address_id}
                      input={<Input id="grouped-native-select" name={'address_id.'+ idx}/>}>
                      <option value="" />
                      {contact_addresses.map((address) => <option id={address.id} value={address.id}>
                        {address.contact.hansa_code} {" - "} 
                        {(address.contact.client) ? address.contact.client.business_name : address.contact.subcontact.firstname + ' ' + address.contact.subcontact.lastname }
                         {" - "}
                        {JSON.parse(address.data).formatted_address} 
                    </option>)}
                  </Select> 
                  {(error !=='' && addresses.address_id ==='') && <FormHelperText style={{color: 'red'}}>Debe completar este campo</FormHelperText>}        
                </FormControl>
              :
                <TextField
                  id={"address_id."+ idx}
                  name={"address_id."+ idx}
                  label="Dirección"
                  disabled={true}
                  type="text"
                  value={getAddress(addresses.address_ids[idx].address_id)}
                  margin="normal"
                  className="mr-2 "
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{style:{minWidth: 300, fontSize: '0.75rem'}}} 
                />
              }
              <div class="mt-4" style={{width:"min-content", display:"inline-flex"}}>   

                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleRemoveItem(e, idx)}}
                disabled={(addresses.address_ids.length == 1) ? true : false} >
                  <RemoveIcon className={classes.deleteIcon} />
                </IconButton>
                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {handleAddItem(e)}}>
                      <AddIcon className={classes.deleteIcon}/>
                </IconButton>
              </div>
            </div>
          </React.Fragment>
        )
      })
      }

    </React.Fragment>
    )
}
export default Addresses;
